export class PublishData {
    hidden: boolean = false;
    timeOn?: Date;
    timeOff?: Date;

    constructor(source?: any) {
        if (source) {
            this.hidden = source.hidden;

            if (source.timeOn) {
                this.timeOn = new Date(source.timeOn);
            }

            if (source.timeOff) {
                this.timeOff = new Date(source.timeOff);
            }
        }
    }

    get obscure(): boolean {
        const now = new Date();
        return this.hidden
            || !!this.timeOn && (this.timeOn > now)
            || !!this.timeOff && (this.timeOff < now);
    }
}
